module.exports = __webpack_public_path__ + "static/corn-b9f6829446bc8acc565aeb5698fa4b7b.svg";